import { render, staticRenderFns } from "./TableCreatives.vue?vue&type=template&id=a17042fc&scoped=true&"
import script from "./TableCreatives.vue?vue&type=script&lang=js&"
export * from "./TableCreatives.vue?vue&type=script&lang=js&"
import style0 from "./TableCreatives.vue?vue&type=style&index=0&id=a17042fc&prod&lang=scss&"
import style1 from "./TableCreatives.vue?vue&type=style&index=1&id=a17042fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17042fc",
  null
  
)

export default component.exports